import { render } from "./FacetPanelTree.vue?vue&type=template&id=db22b4ac&scoped=true&ts=true"
import script from "./FacetPanelTree.vue?vue&type=script&lang=ts"
export * from "./FacetPanelTree.vue?vue&type=script&lang=ts"

import "./FacetPanelTree.vue?vue&type=style&index=0&id=db22b4ac&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db22b4ac"]])

export default __exports__